import { logWithOffset } from "../logWithOffset";
import facebook  from './event_handlers/facebook';
import google    from './event_handlers/google';
import klaviyo   from './event_handlers/klaviyo';
import server    from './event_handlers/server';
import refersion from './event_handlers/refersion';
import segment   from './event_handlers/segment';

const handlers = [ facebook, google, klaviyo, server, refersion, segment ];

const seen = {};

export async function setupEvents(settings) {
  logWithOffset("Initializing Event System");
  await Promise.all([ handlers.map(x => x.setup(settings) ) ]);
  logWithOffset("Event System Ready");

}

export async function fireEvent(e) {
  if (!e.eventId) {
    console.warn("Event Ignored: no event ID");
    console.warn(JSON.stringify(e, null, 4));
    return;
  }
  if (e.eventId in seen) {
    console.warn("Event Ignored: Duplicate");
    console.warn(JSON.stringify(e, null, 4));
    return;
  }

  seen[e.eventId] = true;

  await Promise.all([ handlers.map(x => x.fire(e) ) ]);
}
